// src/utils/backend.js

export function getDuoApiBaseUrl() {
    const host = window.location.hostname;

    if (host.includes("train")) {
        return "https://us-central1-ms-ops-dev.cloudfunctions.net/duoApi";
    } else if (host.includes("test")) {
        return "https://us-central1-ms-ops-test-86dbc.cloudfunctions.net/duoApi";
    } else if (host === "ms-ops.net") {
        return "https://us-central1-ms-ops-production.cloudfunctions.net/duoApi";
    } else {
        console.warn("[DUO] Unknown environment. Defaulting to test.");
        return "https://us-central1-ms-ops-test-86dbc.cloudfunctions.net/duoApi";
    }
}

export function getUsersFunctionUrl() {
    const host = window.location.hostname;

    if (host.includes("train")) {
        return "https://us-central1-ms-ops-dev.cloudfunctions.net/";
    } else if (host.includes("test")) {
        return "https://us-central1-ms-ops-test-86dbc.cloudfunctions.net/";
    } else if (host === "ms-ops.net") {
        return "https://us-central1-ms-ops-production.cloudfunctions.net/";
    } else {
        console.warn("[USERS] Unknown environment. Defaulting to test.");
        return "https://us-central1-ms-ops-test-86dbc.cloudfunctions.net/";
    }
}
